module.exports = __webpack_public_path__ + "static/media/50.5c59f4bb.jpg";